export default __webpack_public_path__ + "static/media/calculator-moneystack6.e9825a73.png";